import { ChannelsNames } from '../Channels';
import { blipDomain, blipDomainUrl, portalDomain, blipWebsocketHostName, blipWebsocketHostNameTenant, messaginghubWebsocketHostName, messaginghubWebsocketHostNameTenant, } from 'app.constants';
import { MessagingHubFeatures } from 'modules/messaginghub/MessagingHubFeatures';
import { FeatureToggleClientService } from 'feature-toggle-client';
// Controllers
import { ChannelBaseController } from '../ChannelBaseController';
export class WhatsAppMfeController extends ChannelBaseController {
    static $inject = ['ChannelsService', 'ApplicationService2', 'application', 'AccountService2', 'LoadingService', 'TranslateService', 'AuthenticationService'];
    constructor(ChannelsService, ApplicationService2, application, AccountService2, LoadingService, TranslateService, AuthenticationService) {
        'ngInject';
        super(ChannelsNames.WhatsApp, ChannelsService, ApplicationService2, application);
        this.ChannelsService = ChannelsService;
        this.ApplicationService2 = ApplicationService2;
        this.application = application;
        this.AccountService2 = AccountService2;
        this.LoadingService = LoadingService;
        this.TranslateService = TranslateService;
        this.AuthenticationService = AuthenticationService;
        this.blipDomain = blipDomain;
        this.blipDomainUrl = blipDomainUrl;
        this.blipWebsocketHostName = messaginghubWebsocketHostNameTenant;
        this.blipWebsocketHostNameTenant = messaginghubWebsocketHostNameTenant;
        this.portalDomain = portalDomain;
        this.readyToRender = false;
        this.isMasterApplication = false;
    }
    async $onInit() {
        const useDelegation = await MessagingHubFeatures.GetMessagingHubCommandWithDelegation();
        this.featureFlags = FeatureToggleClientService.getInstance().getUserInstance().allFlags();
        this.currentUser = await this.AccountService2.me();
        this.currentLanguage = this.TranslateService.getCurrentLanguage();
        const account = await this.ApplicationService2.getAccount();
        this.botIdentity = account.identity;
        const application = await this.ApplicationService2.getApplication(this.botIdentity.split('@')[0]);
        this.isMasterApplication = this.ApplicationService2.isThisMasterApplication(application);
        this.authToken = useDelegation ? this.AuthenticationService.token : application.accessKey;
        this.blipWebsocketHostName = useDelegation ? blipWebsocketHostName : messaginghubWebsocketHostName;
        this.blipWebsocketHostNameTenant = useDelegation ? blipWebsocketHostNameTenant : messaginghubWebsocketHostNameTenant;
        this.authEmail = this.AuthenticationService.email;
        this.LoadingService.stopLoading();
        this.readyToRender = true;
    }
}
WhatsAppMfeController.$inject = ['ChannelsService', 'ApplicationService2', 'application', 'AccountService2', 'LoadingService', 'TranslateService', 'AuthenticationService'];
